import { useState, useEffect, useCallback, ChangeEvent } from 'react'
import { Card, CardContent, CardHeader } from '@mui/material'
import { useParams } from 'react-router-dom'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import ArrowRightAlt from '@mui/icons-material/ArrowRightAlt'
import Cloud from '@mui/icons-material/Cloud'
import MuiPhoneNumber from 'material-ui-phone-number'
import TextField from '@mui/material/TextField'
import NoMeetingRoomIcon from '@mui/icons-material/NoMeetingRoom'
import VisibilityIcon from '@mui/icons-material/Visibility'
import AutoDeleteIcon from '@mui/icons-material/AutoDelete'
import moment from 'moment'
import {
  ActionButton,
  ButtonsWrapper,
  Column,
  CustomLabel,
  LogWrapper,
  Row,
  SearchInput,
  SearchInputWrapper,
  SearchSelect,
  SearchWrapper,
  WhitelistDateRow,
  Wrapper,
} from './styles'
import { useNotify } from 'react-admin'
import API from '../../services/api'
import { phone } from 'phone'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
// import DashboardIcon from '@mui/icons-material/Dashboard'
import GroupsIcon from '@mui/icons-material/Groups'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import BadgeIcon from '@mui/icons-material/Badge'
import PeopleIcon from '@mui/icons-material/People'
import Add from '@mui/icons-material/Add'
import Edit from '@mui/icons-material/Edit'
import LockPerson from '@mui/icons-material/LockPerson'
import BlockIcon from '@mui/icons-material/Block'
import Delete from '@mui/icons-material/Delete'
import Clear from '@mui/icons-material/Clear'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableFooter from '@mui/material/TableFooter'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import TableHead from '@mui/material/TableHead'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import DescriptionIcon from '@mui/icons-material/Description'
import Alert from '@mui/material/Alert'
import TablePaginationActions from '../../components/TablePaginationActions'

interface IIntegrationType {
  0: string
  1: string
  2: string
}

export const IntegrationType: IIntegrationType = {
  0: 'Eduzz',
  1: 'Guru',
  2: 'TMB',
}

interface ILogType {
  0: string
  1: string
}

export const LogType: ILogType = {
  0: 'SISTEMA',
  1: 'USUÁRIO',
}

interface ILogAction {
  // GROUPS -> 1000-2000
  1000: string
  1001: string
  1002: string

  // INTEGRATIONS -> 2000-3000
  2000: string
  2001: string
  2002: string

  // CLIENTS -> 3000-4000
  3000: string
  3001: string
  3002: string
  3003: string
  3004: string

  // ACCESS -> 4000-5000
  4000: string
  4001: string
  4002: string
  4003: string

  // ENTRANCES -> 5000-6000
  5000: string

  // WHITELISTS -> 6000-7000
  6000: string
  6001: string
  6002: string

  // LOGS -> 7000-8000

  // IMPORTS -> 8000-9000

  // OTHER -> 10000-11000
  10000: string
  10001: string
  10002: string
  10003: string
}

export const LogAction: ILogAction = {
  // GROUPS -> 1000-2000
  1000: 'Grupo Criado',
  1001: 'Grupo Atualizado',
  1002: 'Grupo Deletado',

  // INTEGRATIONS -> 2000-3000
  2000: 'Integração Criada',
  2001: 'Integração Atualizada',
  2002: 'Integração Deletada',

  // CLIENTS -> 3000-4000
  3000: 'Cliente Criado',
  3001: 'Cliente Atualizado',
  3002: 'Cliente Deletado',
  3003: 'TelegramID Removido',
  3004: 'Clientes Importados',

  // ACCESS -> 4000-5000
  4000: 'Acesso Criado',
  4001: 'Acesso Atualizado',
  4002: 'Acesso Deletado',
  4003: 'Todos os Acessos Deletados',

  // ENTRANCES -> 5000-6000
  5000: 'Entrada Deletada',

  // WHITELISTS -> 6000-7000
  6000: 'Whitelist Criada',
  6001: 'Whitelist Atualizada',
  6002: 'Whitelist Deletada',

  // LOGS -> 7000-8000

  // IMPORTS -> 8000-9000

  // OTHER -> 10000-11000
  10000: 'Usuario Removido do Grupo',
  10001: 'Usuario se registrou',
  10002: 'Usuario entrou pela Whitelist',
  10003: 'Usuario entrou no grupo',
}

interface IImportLogStatus {
  0: string
  1: string
  2: string
}

export const ImportLogStatus: IImportLogStatus = {
  0: 'PENDENTE',
  1: 'SUCESSO',
  2: 'ERRO',
}

const BotAdm = () => {
  const notify = useNotify()
  const { botId } = useParams()

  // const [botData, setBotData] = useState<any>({})
  const [currentClient, setCurrentClient] = useState({
    id: 0,
    name: '',
    telegramId: '',
  })

  const [currentTab, setCurrentTab] = useState(0)

  const [isAuthDialogOpen, setIsAuthDialogOpen] = useState(false)
  const [isGroupDialogOpen, setIsGroupDialogOpen] = useState(false)
  const [isSectionDialogOpen, setIsSectionDialogOpen] = useState(false)
  const [isIntegrationDialogOpen, setIsIntegrationDialogOpen] = useState(false)
  const [isClientAccessesDialogOpen, setIsClientAccessesDialogOpen] = useState(false)
  const [isWhitelistDialogOpen, setIsWhitelistDialogOpen] = useState(false)

  const [number, setNumber] = useState<any>('')
  const [code, setCode] = useState('')
  const [isWaitingCode, setIsWaitingCode] = useState(true)

  const [groupRows, setGroupRows] = useState<any>([])
  const [groupPage, setGroupPage] = useState(0)
  const [groupRowsPerPage, setGroupRowsPerPage] = useState(5)
  const [groupRowsTotal, setGroupRowsTotal] = useState(0)

  const [whitelistRows, setWhitelistRows] = useState<any>([])
  const [whitelistPage, setWhitelistPage] = useState(0)
  const [whitelistRowsPerPage, setWhitelistRowsPerPage] = useState(5)
  const [whitelistTotal, setWhitelistTotal] = useState(0)

  const [logRows, setLogRows] = useState<any>([])
  const [logPage, setLogPage] = useState(0)
  const [logRowsPerPage, setLogRowsPerPage] = useState(5)
  const [logTotal, setLogTotal] = useState(0)

  const [importLogRows, setImportLogRows] = useState<any>([])
  const [importLogPage, setImportLogPage] = useState(0)
  const [importLogRowsPerPage, setImportLogRowsPerPage] = useState(5)
  const [importLogTotal, setImportLogTotal] = useState(0)

  const [scheduledForRemovalRows, setScheduledForRemovalRows] = useState<any>([])
  const [scheduledForRemovalPage, setScheduledForRemovalPage] = useState(0)
  const [scheduledForRemovalRowsPerPage, setScheduledForRemovalRowsPerPage] = useState(5)
  const [scheduledForRemovalTotal, setScheduledForRemovalTotal] = useState(0)

  const [integrationRows, setIntegrationRows] = useState<any>([])
  const [integrationPage, setIntegrationPage] = useState(0)
  const [integrationRowsPerPage, setIntegrationRowsPerPage] = useState(5)
  const [integrationTotal, setIntegrationTotal] = useState(0)

  const [integrationList, setIntegrationList] = useState<any>([])

  const [clientRows, setClientRows] = useState<any>([])
  const [clientPage, setClientPage] = useState(0)
  const [clientRowsPerPage, setClientRowsPerPage] = useState(5)
  const [clientsTotal, setClientsTotal] = useState(0)
  const [isClientDialogOpen, setIsClientDialogOpen] = useState(false)
  const [isEditingClients, setIsEditingClients] = useState(false)
  const [clientEmail, setClientEmail] = useState('')
  const [clientName, setClientName] = useState('')
  const [clientPhone, setClientPhone] = useState('')
  const [currentClientId, setCurrentClientId] = useState(0)

  const [clientAccessesRows, setClientAccessesRows] = useState<any>([])
  const [clientAccessesPage, setClientAccessesPage] = useState(0)
  const [clientAccessesRowsPerPage, setClientAccessesRowsPerPage] = useState(5)
  const [clientAccessesTotal, setClientAccessesTotal] = useState(0)
  const [isAccessDialogOpen, setIsAccessDialogOpen] = useState(false)

  const [accessActive, setAccessActive] = useState(false)
  const [accessDate, setAccessDate] = useState('')
  const [currentAccessId, setCurrentAccessId] = useState(0)

  // const [isImporting, setIsImporting] = useState(false)

  const [groupName, setGroupName] = useState('')
  const [groupLink, setGroupLink] = useState('')
  const [chatId, setChatId] = useState('')
  const [groupWatch, setGroupWatch] = useState(false)
  const [isEditingGroup, setIsEditingGroup] = useState(false)
  const [currentGroupId, setCurrentGroupId] = useState(0)

  const [groupsList, setGroupsList] = useState<any>([])

  const [integrationPlatform, setIntegrationPlatform] = useState(0)
  const [integrationGroups, setIntegrationGroups] = useState<any[]>([])
  const [integrationDescription, setIntegrationDescription] = useState('')
  const [integrationProdCode, setIntegrationProdCode] = useState('')
  const [integrationToken, setIntegrationToken] = useState('')
  const [integrationExpiresIn, setIntegrationExpiresIn] = useState(1)
  const [integrationDaysToRemove, setIntegrationDaysToRemove] = useState(0)
  const [integrationIsRecurrence, setIntegrationIsRecurrence] = useState(false)
  const [integrationApiKey, setIntegrationApiKey] = useState('')
  const [integrationPublicKey, setIntegrationPublicKey] = useState('')
  const [integrationEduzzEmail, setIntegrationEduzzEmail] = useState('')
  const [isEditingIntegration, setIsEditingIntegration] = useState(false)
  const [currentIntegrationId, setCurrentIntegrationId] = useState(0)
  const [accessIntegration, setAccessIntegration] = useState(0)
  const [isEditingAccess, setIsEditingAccess] = useState(false)

  const [whitelistName, setWhitelistName] = useState('')
  const [whitelistGroups, setWhitelistGroups] = useState([])
  const [whitelistLifetime, setWhitelistLifetime] = useState(true)
  const [whitelistExpireAt, setWhitelistExpireAt] = useState('')
  const [currentWhitelistId, setCurrentWhitelistId] = useState(0)
  const [isEditingWhitelist, setIsEditingWhitelist] = useState(false)

  const [clientQueryKey, setClientQueryKey] = useState('name')
  const [clientQueryValue, setClientQueryValue] = useState('')

  const [sectionName, setSectionName] = useState('')
  const [sections, setSections] = useState([])
  const [section, setSection] = useState(0)

  const [file, setFile] = useState<File>()

  const [isLogsViewerDialogOpen, setIsLogsViewerDialogOpen] = useState(false)
  const [logBody, setLogBody] = useState<any>('')

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0])
    }
  }

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setGroupPage(newPage)
  }

  const handleChangeWhitelistPage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setWhitelistPage(newPage)
  }

  const handleChangeLogPage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setLogPage(newPage)
  }

  const handleChangeImportLogPage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setImportLogPage(newPage)
  }

  const handleChangeScheduledForRemovalPage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setScheduledForRemovalPage(newPage)
  }

  const handleChangeClientAccessesPage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setClientAccessesPage(newPage)
  }

  const handleChangeClientPage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setClientPage(newPage)
  }

  const handleChangeClientAccessesRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setClientAccessesRowsPerPage(parseInt(event.target.value, 10))
    setClientAccessesPage(0)
  }

  const handleChangeClientRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setClientRowsPerPage(parseInt(event.target.value, 10))
    setClientPage(0)
  }

  const handleChangeIntegrationPage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setIntegrationPage(newPage)
  }

  const handleChangeWhitelistRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setWhitelistRowsPerPage(parseInt(event.target.value, 10))
    setWhitelistPage(0)
  }

  const handleChangeLogRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setLogRowsPerPage(parseInt(event.target.value, 10))
    setLogPage(0)
  }

  const handleChangeImportLogRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setImportLogRowsPerPage(parseInt(event.target.value, 10))
    setImportLogPage(0)
  }

  const handleChangeScheduledForRemovalRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setScheduledForRemovalRowsPerPage(parseInt(event.target.value, 10))
    setScheduledForRemovalPage(0)
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setGroupRowsPerPage(parseInt(event.target.value, 10))
    setGroupPage(0)
  }

  const handleChangeIntegrationRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setIntegrationRowsPerPage(parseInt(event.target.value, 10))
    setIntegrationPage(0)
  }

  // const loadData = useCallback(async () => {
  //   try {
  //     const response = await API.get(`/bots/${botId}`)

  //     // if (!response.data.bot.authenticated) {
  //     //   setIsAuthDialogOpen(true)
  //     // }
  //   } catch (error) {
  //     notify('Ocorreu um erro, tente novamente.', { type: 'error' })
  //   }
  // }, [notify, botId])

  const loadClientAccesses = useCallback(async () => {
    try {
      const response = await API.get(
        `/accesses/client?bot=${botId}&client=${currentClient.id}&page=${
          clientAccessesPage + 1
        }&limit=${clientAccessesRowsPerPage}`
      )

      setClientAccessesRows(response.data.accesses.data)
      setClientAccessesTotal(response.data.accesses.meta.total)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }, [notify, botId, currentClient, clientAccessesPage, clientAccessesRowsPerPage])

  const loadSections = useCallback(async () => {
    try {
      const response = await API.get(`/sections?bot=${botId}&page=1&limit=9999`)

      setSections(response.data.sections.data)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }, [notify, botId])

  const loadBotGroups = useCallback(async () => {
    try {
      const response = await API.get(
        `/groups?bot=${botId}&page=${groupPage + 1}&limit=${groupRowsPerPage}`
      )

      setGroupRows(response.data.groups.data)
      setGroupRowsTotal(response.data.groups.meta.total)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }, [notify, botId, groupPage, groupRowsPerPage])

  const loadBotWhitelist = useCallback(async () => {
    try {
      const response = await API.get(
        `/whitelists?bot=${botId}&page=${whitelistPage + 1}&limit=${whitelistRowsPerPage}`
      )

      setWhitelistRows(response.data.whitelists.data)
      setWhitelistTotal(response.data.whitelists.meta.total)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }, [notify, botId, whitelistPage, whitelistRowsPerPage])

  const loadBotLog = useCallback(async () => {
    try {
      const response = await API.get(
        `/logs?bot=${botId}&page=${logPage + 1}&limit=${logRowsPerPage}`
      )

      setLogRows(response.data.logs.data)
      setLogTotal(response.data.logs.meta.total)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }, [notify, botId, logPage, logRowsPerPage])

  const loadImportLog = useCallback(async () => {
    try {
      const response = await API.get(
        `/imports?bot=${botId}&page=${importLogPage + 1}&limit=${importLogRowsPerPage}`
      )

      setImportLogRows(response.data.imports.data)
      setImportLogTotal(response.data.imports.meta.total)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }, [notify, botId, importLogPage, importLogRowsPerPage])

  const loadScheduledForRemoval = useCallback(async () => {
    try {
      const response = await API.get(
        `/scheduled/removal?bot=${botId}&page=${
          scheduledForRemovalPage + 1
        }&limit=${scheduledForRemovalRowsPerPage}`
      )

      setScheduledForRemovalRows(response.data.scheduledForRemoval.data)
      setScheduledForRemovalTotal(response.data.scheduledForRemoval.meta.total)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }, [notify, botId, scheduledForRemovalPage, scheduledForRemovalRowsPerPage])

  const loadBotIntegrations = useCallback(async () => {
    try {
      const response = await API.get(
        `/integrations?bot=${botId}&page=${integrationPage + 1}&limit=${integrationRowsPerPage}`
      )

      setIntegrationRows(response.data.integrations.data)
      setIntegrationTotal(response.data.integrations.meta.total)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }, [notify, botId, integrationPage, integrationRowsPerPage])

  const loadBotClients = useCallback(async () => {
    try {
      let query = `/clients?bot=${botId}&page=${clientPage + 1}&limit=${clientRowsPerPage}`

      if (clientQueryValue) {
        query = `/clients?bot=${botId}&page=${
          clientPage + 1
        }&limit=${clientRowsPerPage}&queryKey=${clientQueryKey}&queryValue=${clientQueryValue}`
      }

      const response = await API.get(query)

      setClientRows(response.data.clients.data)
      setClientsTotal(response.data.clients.meta.total)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }, [notify, botId, clientPage, clientRowsPerPage, clientQueryKey, clientQueryValue])

  const loadGroupsList = useCallback(async () => {
    try {
      const response = await API.get(`/groups?bot=${botId}&page=1&limit=100`)

      setGroupsList(response.data.groups.data)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }, [notify, botId])

  const loadIntegrationsList = useCallback(async () => {
    try {
      const response = await API.get(`/integrations?bot=${botId}&page=1&limit=100`)

      setIntegrationList(response.data.integrations.data)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }, [notify, botId])

  useEffect(() => {
    // loadData()
    loadBotGroups()
    loadGroupsList()
    loadIntegrationsList()
    loadBotIntegrations()
    loadBotClients()
    loadBotWhitelist()
    loadBotLog()
    loadImportLog()
    loadScheduledForRemoval()
  }, [
    // loadData,
    loadBotGroups,
    loadGroupsList,
    loadIntegrationsList,
    loadBotIntegrations,
    loadBotClients,
    loadBotWhitelist,
    loadBotLog,
    loadImportLog,
    loadScheduledForRemoval,
  ])

  useEffect(() => {
    if (currentClient.id !== 0) {
      loadClientAccesses()
    }
  }, [currentClient, loadClientAccesses])

  useEffect(() => {
    loadBotClients()
  }, [clientQueryValue, loadBotClients])

  useEffect(() => {
    loadIntegrationsList()
  }, [isAccessDialogOpen, loadIntegrationsList])

  const sendPhone = async () => {
    try {
      const phoneData = phone(number)

      if (!phoneData.isValid) {
        return notify('Verifique o número digitado.', { type: 'error' })
      }

      await API.post(`/bots/${botId}/sendPhone`, {
        phone: phoneData.phoneNumber,
      })

      setIsWaitingCode(false)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const sendCode = async () => {
    try {
      const isValidCode = /^\d+$/.test(code)

      if (!isValidCode || code.length !== 5) {
        return notify('Código inválido', { type: 'error' })
      }

      await API.post(`/bots/${botId}/sendCode`, {
        code,
      })

      // TODO: validate if is authenticated

      setIsAuthDialogOpen(false)
      notify('Autenticado com sucesso!', { type: 'success' })
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const createGroup = async () => {
    try {
      const data: any = {
        name: groupName,
        inviteLink: groupLink,
        chatId: chatId,
        check: groupWatch,
        botId,
      }

      if (section && section !== 0) {
        data.sectionId = section
      }

      await API.post('/groups', data)

      setIsGroupDialogOpen(false)
      loadBotGroups()
      loadGroupsList()
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const createClient = async () => {
    try {
      const payload: any = {
        name: clientName,
        email: clientEmail,
        botId,
      }

      if (clientPhone) {
        payload.phone = clientPhone
      }

      await API.post('/clients', payload)

      setIsClientDialogOpen(false)
      loadBotClients()
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const createAccess = async () => {
    try {
      await API.post('/accesses', {
        isValid: accessActive,
        clientId: currentClient.id,
        integrationId: accessIntegration,
        expiresAt: new Date(accessDate),
      })

      setIsAccessDialogOpen(false)
      setAccessActive(false)
      setAccessIntegration(0)
      setAccessDate('')
    } catch (error) {
      notify('Ocorreu um erro, esse acesso pode ja existir.', { type: 'error' })
    }
  }

  const updateAccess = async () => {
    try {
      await API.put(`/accesses/${currentAccessId}`, {
        isValid: accessActive,
        clientId: currentClient.id,
        integrationId: accessIntegration,
        expiresAt: new Date(accessDate),
      })

      setIsAccessDialogOpen(false)
      setAccessActive(false)
      setAccessIntegration(0)
      setAccessDate('')
      setIsEditingAccess(false)
      loadClientAccesses()
    } catch (error) {
      notify('Ocorreu um erro, esse acesso pode ja existir.', { type: 'error' })
    }
  }

  const createWhitelist = async () => {
    try {
      const payload: any = {
        name: whitelistName,
        lifetime: whitelistLifetime,
        groups: whitelistGroups,
        botId,
      }

      if (!whitelistLifetime) {
        payload.expiresAt = whitelistExpireAt
      }

      await API.post('/whitelists', payload)

      setIsWhitelistDialogOpen(false)
      loadBotWhitelist()
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const createSection = async () => {
    try {
      const payload: any = {
        name: sectionName,
        botId,
      }

      await API.post('/sections', payload)

      setIsSectionDialogOpen(false)
      loadGroupsList()
      notify('Separador criado com sucesso!', { type: 'success' })
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const updateWhitelist = async () => {
    try {
      const payload: any = {
        name: whitelistName,
        lifetime: whitelistLifetime,
        groups: whitelistGroups,
        botId,
      }

      if (!whitelistLifetime) {
        payload.expiresAt = whitelistExpireAt
      }

      await API.put(`/whitelists/${currentWhitelistId}`, payload)

      setIsWhitelistDialogOpen(false)
      loadBotWhitelist()
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const createIntegration = async () => {
    try {
      const payload: any = {
        description: integrationDescription,
        type: integrationPlatform,
        productCod: integrationProdCode,
        token: integrationToken,
        groups: integrationGroups,
        botId,
        isRecurrence: integrationIsRecurrence,
        apiKey: integrationApiKey,
        daysToRemove: integrationDaysToRemove,
      }

      if (!integrationIsRecurrence) {
        if (integrationExpiresIn < 1) {
          return notify('O valor deve ser maior que 0', { type: 'error' })
        }

        payload.expiresIn = integrationExpiresIn
      }

      if (integrationPlatform === 0) {
        payload.eduzzEmail = integrationEduzzEmail
        payload.publicKey = integrationPublicKey
      }

      await API.post('/integrations', payload)

      setIsIntegrationDialogOpen(false)
      loadBotIntegrations()
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const importManual = async () => {
    try {
      if (!file) {
        notify('Selecione um arquivo', { type: 'error' })
        return
      }

      const formData = new FormData()
      formData.append('file', file)

      await API.post(`/clients/import/${botId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      notify('Arquivo enviado, para ver o progresso da importação verifique os logs', {
        type: 'success',
      })
      window.location.reload()
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const deleteGroup = async (groupId: number) => {
    try {
      if (!window.confirm('Tem certeza que deseja remover esse grupo?')) return

      await API.delete(`/groups/${groupId}`)

      notify('Grupo removido com sucesso', {
        type: 'success',
      })

      loadBotGroups()
    } catch (error) {
      notify('Existem integrações e/ou whitelists linkadas á este grupo, remova-as primerio.', {
        type: 'error',
      })
    }
  }

  const deleteWhitelist = async (whitelistId: number) => {
    try {
      if (!window.confirm('Tem certeza que deseja remover essa whitelist?')) return

      await API.delete(`/whitelists/${whitelistId}`)

      notify('Whitelist removida com sucesso', {
        type: 'success',
      })

      loadBotWhitelist()
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const deleteIntegration = async (integrationId: number) => {
    try {
      if (!window.confirm('Tem certeza que deseja remover essa integração?')) return

      await API.delete(`/integrations/${integrationId}`)

      notify('Integração removida com sucesso', {
        type: 'success',
      })

      loadBotIntegrations()
    } catch (error) {
      notify('Existem acessos linkados a esta integração, remova-os primeiro.', {
        type: 'error',
      })
    }
  }

  const deleteClient = async (clientId: number) => {
    try {
      if (!window.confirm('Tem certeza que deseja remover esse cliente?')) return

      await API.delete(`/clients/${clientId}`)

      notify('Cliente removido com sucesso', {
        type: 'success',
      })

      loadBotClients()
    } catch (error) {
      notify('Existem acessos linkados a este cliente, remova-os primeiro.', {
        type: 'error',
      })
    }
  }

  const deleteAccess = async (accessId: number) => {
    try {
      if (!window.confirm('Tem certeza que deseja remover esse acesso?')) return

      await API.delete(`/accesses/${accessId}`)

      notify('Acesso removido com sucesso', {
        type: 'success',
      })

      setIsClientAccessesDialogOpen(false)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', {
        type: 'error',
      })
    }
  }

  const fetchOneIntegration = async (integrationId: number) => {
    try {
      const response = await API.get(`/integrations/${integrationId}`)

      const groupsToUpdate: any = []

      const { integration } = response.data

      if (integration.groups) {
        integration.groups.forEach((group: any) => {
          groupsToUpdate.push(group.id)
        })
      }

      loadGroupsList()
      setCurrentIntegrationId(integrationId)
      setIntegrationIsRecurrence(integration.is_recurrence)
      setIntegrationExpiresIn(integration.expires_in)
      setIntegrationDaysToRemove(integration.days_to_remove)
      setIntegrationDescription(integration.description)
      setIntegrationToken(integration.token)
      setIntegrationApiKey(integration.api_key)
      setIntegrationPublicKey(integration.public_key)
      setIntegrationEduzzEmail(integration.eduzz_email)
      setIntegrationPlatform(integration.type)
      setIntegrationGroups(groupsToUpdate)
      setIsEditingIntegration(true)
      setIsIntegrationDialogOpen(true)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const fetchOneGroup = async (groupId: number) => {
    try {
      const response = await API.get(`/groups/${groupId}`)
      setGroupName(response.data.group.name)
      setGroupLink(response.data.group.invite_link)
      setGroupWatch(response.data.group.check)
      setSection(response.data.group.section_id || 0)
      setCurrentGroupId(groupId)
      setIsEditingGroup(true)
      setIsGroupDialogOpen(true)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const fetchOneWhitelist = async (whitelistId: number) => {
    try {
      const response = await API.get(`/whitelists/${whitelistId}`)

      const groups: any = []

      for (const group of response.data.whitelist.groups) {
        groups.push(group.id)
      }

      setWhitelistName(response.data.whitelist.name)
      setWhitelistGroups(groups)
      setWhitelistExpireAt(response.data.whitelist.expires_at)
      setWhitelistLifetime(response.data.whitelist.lifetime)
      setCurrentWhitelistId(whitelistId)
      setIsEditingWhitelist(true)
      setIsWhitelistDialogOpen(true)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const fetchOneAccess = async (accessId: number) => {
    try {
      const response = await API.get(`/accesses/${accessId}`)
      loadIntegrationsList()
      setAccessActive(response.data.access.is_valid)
      setAccessIntegration(response.data.access.integration_id)
      setAccessDate(moment(response.data.access.expires_at).format('YYYY-MM-DD'))
      setCurrentAccessId(accessId)
      setIsEditingAccess(true)
      setIsAccessDialogOpen(true)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const fetchOneClient = async (clientId: number) => {
    try {
      const response = await API.get(`/clients/${clientId}`)
      setClientName(response.data.client.name)
      setClientEmail(response.data.client.email)
      setClientPhone(response.data.client.phone)
      setCurrentClientId(clientId)
      setIsEditingClients(true)
      setIsClientDialogOpen(true)
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const editIntegration = async () => {
    try {
      const payload: any = {
        description: integrationDescription,
        token: integrationToken,
        groups: integrationGroups,
        apiKey: integrationApiKey,
        daysToRemove: integrationDaysToRemove,
      }

      if (!integrationIsRecurrence) {
        if (integrationExpiresIn < 1) {
          return notify('O valor deve ser maior que 0', { type: 'error' })
        }

        payload.expiresIn = integrationExpiresIn
      }

      if (integrationPlatform === 0) {
        payload.eduzzEmail = integrationEduzzEmail
        payload.publicKey = integrationPublicKey
      }

      await API.put(`/integrations/${currentIntegrationId}`, payload)

      setIsEditingIntegration(false)
      setIsIntegrationDialogOpen(false)
      loadBotIntegrations()
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const editGroup = async () => {
    try {
      const data: any = {
        name: groupName,
        inviteLink: groupLink,
        check: groupWatch,
      }

      if (section && section !== 0) {
        data.sectionId = section
      }

      await API.put(`/groups/${currentGroupId}`, data)

      notify('Grupo editado com sucesso', {
        type: 'success',
      })
      setIsEditingGroup(false)
      setIsGroupDialogOpen(false)
      loadBotGroups()
      loadGroupsList()
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const editClient = async () => {
    try {
      const payload: any = {
        name: clientName,
        email: clientEmail,
      }

      if (clientPhone) {
        payload.phone = clientPhone
      }

      await API.put(`/clients/${currentClientId}`, payload)

      notify('Cliente editado com sucesso', {
        type: 'success',
      })
      setIsEditingClients(false)
      setIsClientDialogOpen(false)
      loadBotClients()
    } catch (error) {
      notify('Ocorreu um erro, tente novamente.', { type: 'error' })
    }
  }

  const removeTelegramId = async (clientId: number) => {
    try {
      if (
        !window.confirm(
          'Tem certeza que deseja remover o vínculo deste cadastro com o telegram do cliente?'
        )
      )
        return

      await API.post(`/clients/${clientId}`)

      notify('Telegram ID removido com sucesso', {
        type: 'success',
      })
      loadBotClients()
    } catch (error) {
      notify('Falha ao remover telegramId', { type: 'error' })
    }
  }

  const renderLogRow = () => {
    if (!logBody) {
      return <></>
    }

    const render = []

    const parsedLogBody = JSON.parse(logBody)

    let i = 0

    for (const row in parsedLogBody) {
      render.push(
        <span
          style={{ marginTop: i > 0 ? '10px' : '0', display: 'block' }}
        >{`${row}: ${parsedLogBody[row]}`}</span>
      )
      render.push(<br />)
      i++
    }

    return render
  }

  // const autoImport = async (integrationId: number) => {
  //   try {
  //     setIsImporting(true)
  //     await API.post(`/integrations/import/${botId}/${integrationId}`)

  //     notify('Importação iniciada', { type: 'success' })
  //     setIsImporting(false)
  //     loadBotClients()
  //   } catch (error) {
  //     notify('Ocorreu um erro, tente novamente.', { type: 'error' })
  //     setIsImporting(false)
  //   }
  // }

  return (
    <Card>
      {/* {isImporting && (
        <div
          style={{
            position: 'absolute',
            marginLeft: 'auto',
            marginRight: 'auto',
            left: 0,
            right: 0,
            textAlign: 'center',
            top: '50%',
          }}
        >
          <span style={{ color: 'red', fontSize: '30px' }}>
            Não feche ou recarregue a página, aguarde...
          </span>
        </div>
      )} */}

      <Tabs
        value={currentTab}
        onChange={(_, newValue) => setCurrentTab(newValue)}
        aria-label="icon label tabs example"
        TabIndicatorProps={{ style: { background: '#006C9C' } }}
      >
        {/* <Tab icon={<DashboardIcon />} label="DASHBOARD" /> */}
        <Tab
          style={{ color: currentTab === 0 ? '#006C9C' : '#666666' }}
          icon={<GroupsIcon />}
          label="GRUPOS"
        />
        <Tab
          style={{ color: currentTab === 1 ? '#006C9C' : '#666666' }}
          icon={<AddShoppingCartIcon />}
          label="INTEGRAÇÕES"
        />
        <Tab
          style={{ color: currentTab === 2 ? '#006C9C' : '#666666' }}
          icon={<PeopleIcon />}
          label="CLIENTES"
        />
        <Tab
          style={{ color: currentTab === 3 ? '#006C9C' : '#666666' }}
          icon={<AutoDeleteIcon />}
          label="AGENDADOS PARA REMOÇÃO"
        />
        <Tab
          style={{ color: currentTab === 4 ? '#006C9C' : '#666666' }}
          icon={<BadgeIcon />}
          label="WHITELIST"
        />
        <Tab
          style={{ color: currentTab === 5 ? '#006C9C' : '#666666' }}
          icon={<DescriptionIcon />}
          label="LOGS"
        />
        <Tab
          style={{ color: currentTab === 6 ? '#006C9C' : '#666666' }}
          icon={<DescriptionIcon />}
          label="LOGS IMPORTAÇÃO"
        />
      </Tabs>

      {/* {currentTab === 0 && (
        <Card>
          <CardHeader title="Dashboard" />
          <CardContent>
            Autenticado:{' '}
            {botData.authenticated ? (
              <span style={{ color: 'green' }}>Sim</span>
            ) : (
              <span style={{ color: 'red' }}>Não</span>
            )}
          </CardContent>
        </Card>
      )} */}

      {currentTab === 0 && (
        <Card>
          <CardHeader title="Grupos" />
          <CardContent>
            <Button
              sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
              variant="contained"
              endIcon={<Add />}
              onClick={() => {
                loadSections()
                setIsGroupDialogOpen(true)
                setIsEditingGroup(false)
                setGroupName('')
                setGroupLink('')
                setChatId('')
                setGroupWatch(false)
              }}
            >
              Criar
            </Button>

            <Button
              sx={{
                'backgroundColor': '#007867',
                '&:hover': { backgroundColor: '#007867' },
                'marginLeft': '10px',
              }}
              variant="contained"
              endIcon={<Add />}
              onClick={() => {
                setIsSectionDialogOpen(true)
                setSectionName('')
              }}
            >
              Criar Separador
            </Button>

            <Wrapper>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell align="left">Nome</TableCell>
                      <TableCell>Monitorar</TableCell>
                      <TableCell>Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {groupRows.map((row: any) => (
                      <TableRow key={row.id}>
                        <TableCell style={{ width: 20 }} component="th" scope="row">
                          {row.id}
                        </TableCell>
                        <TableCell style={{ flex: 1 }}>{row.name}</TableCell>
                        <TableCell style={{ width: 200 }}>{row.check ? 'Sim' : 'Não'}</TableCell>
                        <TableCell style={{ width: 200 }}>
                          <ActionButton
                            style={{ color: '#00A76F' }}
                            title="Editar Grupo"
                            onClick={() => {
                              fetchOneGroup(row.id)
                              loadSections()
                            }}
                          >
                            <Edit />
                          </ActionButton>
                          <ActionButton
                            style={{ marginLeft: '5px', color: '#B71D18' }}
                            title="Remover Grupo"
                            onClick={() => deleteGroup(row.id)}
                          >
                            <Delete />
                          </ActionButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={3}
                        count={groupRowsTotal}
                        rowsPerPage={groupRowsPerPage}
                        page={groupPage}
                        SelectProps={{
                          inputProps: {
                            'aria-label': 'rows per page',
                          },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Wrapper>
          </CardContent>
        </Card>
      )}

      {currentTab === 1 && (
        <Card>
          <CardHeader title="Integrações" />
          <CardContent>
            <Button
              sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
              variant="contained"
              endIcon={<Add />}
              onClick={() => {
                setIsIntegrationDialogOpen(true)
                setIsEditingIntegration(false)
                setIntegrationPlatform(0)
                setIntegrationGroups([])
                setIntegrationDescription('')
                setIntegrationProdCode('')
                setCurrentIntegrationId(0)
                setIntegrationToken('')
                setIntegrationPublicKey('')
                setIntegrationIsRecurrence(false)
                setIntegrationExpiresIn(1)
                setIntegrationExpiresIn(0)
                setIntegrationEduzzEmail('')
                setIntegrationApiKey('')
              }}
            >
              Criar
            </Button>

            <Wrapper>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell align="left">Descrição</TableCell>
                      <TableCell>Tipo</TableCell>
                      <TableCell>Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {integrationRows.map((row: any) => (
                      <TableRow key={row.id}>
                        <TableCell style={{ width: 20 }} component="th" scope="row">
                          {row.id}
                        </TableCell>
                        <TableCell style={{ flex: 1 }}>{row.description}</TableCell>
                        <TableCell style={{ width: 200 }}>
                          {IntegrationType[row.type as keyof IIntegrationType]}
                        </TableCell>
                        <TableCell style={{ width: 200 }}>
                          <ActionButton
                            style={{ color: '#00A76F' }}
                            title="Editar Integração"
                            onClick={() => {
                              fetchOneIntegration(row.id)
                            }}
                          >
                            <Edit />
                          </ActionButton>
                          <ActionButton
                            style={{ marginLeft: '5px', color: '#B71D18' }}
                            title="Remover Integração"
                            onClick={() => deleteIntegration(row.id)}
                          >
                            <Delete />
                          </ActionButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={3}
                        count={integrationTotal}
                        rowsPerPage={integrationRowsPerPage}
                        page={integrationPage}
                        SelectProps={{
                          inputProps: {
                            'aria-label': 'rows per page',
                          },
                          native: true,
                        }}
                        onPageChange={handleChangeIntegrationPage}
                        onRowsPerPageChange={handleChangeIntegrationRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Wrapper>
          </CardContent>
        </Card>
      )}

      {currentTab === 2 && (
        <Card>
          <CardHeader title="Clientes" />
          <CardContent>
            <Column>
              <input type="file" onChange={handleFileChange} />

              <ButtonsWrapper>
                <div>
                  <Button
                    sx={{ 'backgroundColor': '#B71D18', '&:hover': { backgroundColor: '#B71D18' } }}
                    variant="contained"
                    endIcon={<Add />}
                    onClick={() => {
                      importManual()
                    }}
                  >
                    Importar
                  </Button>
                  <Button
                    sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
                    variant="contained"
                    endIcon={<Add />}
                    style={{ marginLeft: '10px' }}
                    onClick={() => {
                      setIsEditingClients(false)
                      setIsClientDialogOpen(true)
                      setClientName('')
                      setClientEmail('')
                      setClientPhone('')
                    }}
                  >
                    Criar
                  </Button>
                </div>

                <SearchWrapper>
                  <SearchInputWrapper>
                    <SearchSelect
                      value={clientQueryKey}
                      onChange={(ev) => {
                        setClientQueryKey(ev.target.value)
                      }}
                    >
                      <option value="name">Nome</option>
                      <option value="email">Email</option>
                      <option value="phone">Telefone</option>
                      <option value="telegram_id">Telegram ID</option>
                    </SearchSelect>

                    <SearchInput
                      placeholder="Digite aqui para pesquisar"
                      value={clientQueryValue}
                      onChange={(ev) => {
                        setClientQueryValue(ev.target.value)
                      }}
                    />
                  </SearchInputWrapper>

                  <Button
                    sx={{ 'backgroundColor': '#FEC144', '&:hover': { backgroundColor: '#FEC144' } }}
                    variant="contained"
                    endIcon={<Add />}
                    onClick={() => {
                      window.open(
                        `${
                          process.env.NODE_ENV === 'development'
                            ? 'http://localhost'
                            : 'https://api.connectm.com.br'
                        }:3333/import.csv`,
                        '_blank'
                      )
                    }}
                  >
                    Baixar Modelo
                  </Button>
                </SearchWrapper>
              </ButtonsWrapper>
            </Column>

            <Wrapper>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell align="left">Nome</TableCell>
                      <TableCell align="left">Email</TableCell>
                      <TableCell align="left">Telefone</TableCell>
                      <TableCell align="left">Telegram ID</TableCell>
                      <TableCell>Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {clientRows.map((row: any) => {
                      return (
                        <TableRow key={row.id}>
                          <TableCell style={{ width: 20 }} component="th" scope="row">
                            {row.id}
                          </TableCell>
                          <TableCell style={{ flex: 1 }}>{row.name}</TableCell>
                          <TableCell style={{ flex: 1 }}>{row.email}</TableCell>
                          <TableCell style={{ flex: 1 }}>{row.phone}</TableCell>
                          <TableCell style={{ flex: 1 }}>
                            {row.telegram_id || 'Não se cadastrou'}
                          </TableCell>
                          <TableCell style={{ width: 200 }}>
                            <ActionButton
                              style={{ color: '#00A76F' }}
                              title="Editar Cliente"
                              onClick={() => {
                                fetchOneClient(row.id)
                              }}
                            >
                              <Edit />
                            </ActionButton>
                            <ActionButton
                              style={{ color: '#2196F3', marginLeft: '5px' }}
                              title="Accessos do Cliente"
                              onClick={() => {
                                setIsClientAccessesDialogOpen(true)
                                setCurrentClient({
                                  id: row.id,
                                  name: row.name,
                                  telegramId: row.telegram_id || '',
                                })
                              }}
                            >
                              <LockPerson />
                            </ActionButton>
                            <ActionButton
                              style={{ color: '#B71D18', marginLeft: '5px' }}
                              title="Remover Telegram ID"
                              onClick={() => {
                                removeTelegramId(row.id)
                              }}
                            >
                              <NoMeetingRoomIcon />
                            </ActionButton>
                            <ActionButton
                              title="Remover Cliente"
                              style={{ marginLeft: '5px', color: '#B71D18' }}
                              onClick={() => deleteClient(row.id)}
                            >
                              <Delete />
                            </ActionButton>
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={3}
                        count={clientsTotal}
                        rowsPerPage={clientRowsPerPage}
                        page={clientPage}
                        SelectProps={{
                          inputProps: {
                            'aria-label': 'rows per page',
                          },
                          native: true,
                        }}
                        onPageChange={handleChangeClientPage}
                        onRowsPerPageChange={handleChangeClientRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Wrapper>
          </CardContent>
        </Card>
      )}

      {currentTab === 3 && (
        <Card>
          <CardHeader title="Agendados para remoção" />
          <CardContent>
            <Wrapper>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell align="left">Cliente</TableCell>
                      <TableCell>Data</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {scheduledForRemovalRows.map((row: any) => (
                      <TableRow key={row.id}>
                        <TableCell style={{ width: 20 }} component="th" scope="row">
                          {row.id}
                        </TableCell>
                        <TableCell style={{ flex: 1 }}>{row.access.client.name}</TableCell>
                        <TableCell style={{ width: 200 }}>
                          {moment(row.expires_at).format('DD/MM/YYYY HH:mm:ss')}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={3}
                        count={scheduledForRemovalTotal}
                        rowsPerPage={scheduledForRemovalRowsPerPage}
                        page={scheduledForRemovalPage}
                        SelectProps={{
                          inputProps: {
                            'aria-label': 'rows per page',
                          },
                          native: true,
                        }}
                        onPageChange={handleChangeScheduledForRemovalPage}
                        onRowsPerPageChange={handleChangeScheduledForRemovalRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Wrapper>
          </CardContent>
        </Card>
      )}

      {currentTab === 4 && (
        <Card>
          <CardHeader title="Whitelist" />
          <CardContent>
            <Button
              sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
              variant="contained"
              endIcon={<Add />}
              onClick={() => {
                setIsWhitelistDialogOpen(true)
                setWhitelistExpireAt('')
                setWhitelistName('')
                setWhitelistGroups([])
                setWhitelistLifetime(false)
              }}
            >
              Criar
            </Button>

            <Wrapper>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell align="left">Nome</TableCell>
                      <TableCell>Código</TableCell>
                      <TableCell>Vitalício</TableCell>
                      <TableCell>Expira em</TableCell>
                      <TableCell>Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {whitelistRows.map((row: any) => (
                      <TableRow key={row.id}>
                        <TableCell style={{ width: 20 }} component="th" scope="row">
                          {row.id}
                        </TableCell>
                        <TableCell style={{ flex: 1 }}>{row.name}</TableCell>
                        <TableCell style={{ width: 200 }}>{row.code}</TableCell>
                        <TableCell style={{ width: 200 }}>{row.lifetime ? 'Sim' : 'Não'}</TableCell>
                        <TableCell style={{ width: 200 }}>{row.expiresAt || '-'}</TableCell>
                        <TableCell style={{ width: 200 }}>
                          <ActionButton
                            style={{ color: '#00A76F' }}
                            title="Editar Whitelist"
                            onClick={() => fetchOneWhitelist(row.id)}
                          >
                            <Edit />
                          </ActionButton>
                          <ActionButton
                            title="Remover Whitelist"
                            style={{ marginLeft: '5px', color: '#B71D18' }}
                            onClick={() => deleteWhitelist(row.id)}
                          >
                            <Delete />
                          </ActionButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={3}
                        count={whitelistTotal}
                        rowsPerPage={whitelistRowsPerPage}
                        page={whitelistPage}
                        SelectProps={{
                          inputProps: {
                            'aria-label': 'rows per page',
                          },
                          native: true,
                        }}
                        onPageChange={handleChangeWhitelistPage}
                        onRowsPerPageChange={handleChangeWhitelistRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Wrapper>
          </CardContent>
        </Card>
      )}

      {currentTab === 5 && (
        <Card>
          <CardHeader title="Logs" />
          <CardContent>
            <Wrapper>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell align="left">Ação</TableCell>
                      <TableCell>Tipo</TableCell>
                      <TableCell>Ref</TableCell>
                      <TableCell>Data</TableCell>
                      <TableCell>Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {logRows.map((row: any) => (
                      <TableRow key={row.id}>
                        <TableCell style={{ width: 20 }} component="th" scope="row">
                          {row.id}
                        </TableCell>
                        <TableCell style={{ flex: 1 }}>
                          {LogAction[row.action as keyof ILogAction]}
                        </TableCell>
                        <TableCell style={{ width: 200 }}>
                          {LogType[row.type as keyof ILogType]}
                        </TableCell>
                        <TableCell style={{ width: 200 }}>{row.ref}</TableCell>
                        <TableCell style={{ width: 200 }}>
                          {moment(row.created_at).format('DD/MM/YYYY HH:mm:ss')}
                        </TableCell>
                        <TableCell style={{ width: 200 }}>
                          <ActionButton
                            style={{ color: '#1976D2' }}
                            title="Ver Body"
                            onClick={() => {
                              setIsLogsViewerDialogOpen(true)
                              setLogBody(row.body)
                            }}
                          >
                            <VisibilityIcon />
                          </ActionButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={3}
                        count={logTotal}
                        rowsPerPage={logRowsPerPage}
                        page={logPage}
                        SelectProps={{
                          inputProps: {
                            'aria-label': 'rows per page',
                          },
                          native: true,
                        }}
                        onPageChange={handleChangeLogPage}
                        onRowsPerPageChange={handleChangeLogRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Wrapper>
          </CardContent>
        </Card>
      )}

      {currentTab === 6 && (
        <Card>
          <CardHeader title="Logs Importação" />
          <CardContent>
            <Wrapper>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell align="left">Mensagem</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Nome do Arquivo</TableCell>
                      <TableCell>Data</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {importLogRows.map((row: any) => (
                      <TableRow key={row.id}>
                        <TableCell style={{ width: 20 }} component="th" scope="row">
                          {row.id}
                        </TableCell>
                        <TableCell style={{ flex: 1 }}>{row.message}</TableCell>
                        <TableCell style={{ width: 200 }}>
                          {ImportLogStatus[row.status as keyof IImportLogStatus]}
                        </TableCell>
                        <TableCell style={{ width: 200 }}>{row.original_filename}</TableCell>
                        <TableCell style={{ width: 200 }}>
                          {moment(row.created_at).format('DD/MM/YYYY HH:mm:ss')}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={3}
                        count={importLogTotal}
                        rowsPerPage={importLogRowsPerPage}
                        page={importLogPage}
                        SelectProps={{
                          inputProps: {
                            'aria-label': 'rows per page',
                          },
                          native: true,
                        }}
                        onPageChange={handleChangeImportLogPage}
                        onRowsPerPageChange={handleChangeImportLogRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Wrapper>
          </CardContent>
        </Card>
      )}

      <Dialog open={isLogsViewerDialogOpen} fullWidth maxWidth="lg">
        <DialogContent>
          <LogWrapper>{renderLogRow()}</LogWrapper>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ 'backgroundColor': '#B71D18', '&:hover': { backgroundColor: '#B71D18' } }}
            variant="contained"
            endIcon={<Clear />}
            onClick={() => {
              setIsLogsViewerDialogOpen(false)
            }}
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isClientAccessesDialogOpen} fullWidth maxWidth="lg">
        <DialogTitle>Acessos do Cliente ({currentClient.name})</DialogTitle>

        <DialogContent>
          <Button
            sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
            variant="contained"
            endIcon={<Add />}
            style={{ marginBottom: '10px' }}
            onClick={() => {
              setIsClientAccessesDialogOpen(false)
              setIsAccessDialogOpen(true)
              setAccessIntegration(0)
              setAccessActive(false)
              setAccessDate('')
            }}
          >
            Criar
          </Button>

          {clientAccessesRows.length > 0 ? (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell align="left">Integração</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Expira em</TableCell>
                    <TableCell align="left">Válido?</TableCell>
                    <TableCell>Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {clientAccessesRows.map((row: any) => (
                    <TableRow key={row.id}>
                      <TableCell style={{ width: 20 }} component="th" scope="row">
                        {row.id}
                      </TableCell>
                      <TableCell style={{ flex: 1 }}>
                        {row.integration?.description || '?'}
                      </TableCell>
                      <TableCell style={{ flex: 1 }}>{row.status || '?'}</TableCell>
                      <TableCell style={{ flex: 1 }}>
                        {row.expires_at
                          ? moment(row.expires_at).format('DD/MM/YYYY HH:mm:ss')
                          : 'Recorrência'}
                      </TableCell>
                      <TableCell style={{ flex: 1 }}>{row.is_valid ? 'Sim' : 'Não'}</TableCell>
                      <TableCell style={{ width: 200 }}>
                        <ActionButton
                          style={{ color: '#00A76F', marginRight: '10px' }}
                          title="Editar Acesso"
                          onClick={() => {
                            fetchOneAccess(row.id)
                          }}
                        >
                          <Edit />
                        </ActionButton>
                        <ActionButton
                          title="Remover Acesso"
                          style={{ color: '#B71D18' }}
                          onClick={() => {
                            deleteAccess(row.id)
                          }}
                        >
                          <Delete />
                        </ActionButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      colSpan={3}
                      count={clientAccessesTotal}
                      rowsPerPage={clientAccessesRowsPerPage}
                      page={clientAccessesPage}
                      SelectProps={{
                        inputProps: {
                          'aria-label': 'rows per page',
                        },
                        native: true,
                      }}
                      onPageChange={handleChangeClientAccessesPage}
                      onRowsPerPageChange={handleChangeClientAccessesRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          ) : (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <BlockIcon style={{ color: 'red', fontSize: '8rem' }} />
              <span style={{ fontSize: '2rem' }}>Sem dados</span>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ 'backgroundColor': '#B71D18', '&:hover': { backgroundColor: '#B71D18' } }}
            variant="contained"
            endIcon={<Clear />}
            onClick={() => {
              setIsClientAccessesDialogOpen(false)
            }}
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isIntegrationDialogOpen}>
        <DialogTitle>{isEditingIntegration ? 'Editar' : 'Criar'} Integração</DialogTitle>

        <Alert severity="warning">
          Caso utilize o Guru com alguma outra plataforma, Ex: Eduzz, cadastre somente uma (Ou o
          guru ou a Eduzz) pois caso tenha as duas cadastradas poderá ocorrer problemas
        </Alert>

        <DialogContent>
          {!isEditingIntegration && (
            <Column>
              <Select
                margin="dense"
                variant="standard"
                fullWidth
                value={integrationPlatform}
                onChange={(ev: any) => {
                  setIntegrationPlatform(ev.target.value)
                }}
              >
                <MenuItem value={0}>Eduzz</MenuItem>
                <MenuItem value={1}>Guru</MenuItem>
                <MenuItem value={2}>TMB</MenuItem>
              </Select>

              <CustomLabel> a Plataforma</CustomLabel>
            </Column>
          )}
          <Column style={{ marginTop: '16px' }}>
            <Select
              margin="dense"
              multiple
              variant="standard"
              fullWidth
              value={integrationGroups}
              onChange={(ev: any) => {
                setIntegrationGroups(ev.target.value)
              }}
            >
              {groupsList.map((group: any) => {
                return (
                  <MenuItem key={group.id} value={group.id}>
                    {group.name}
                  </MenuItem>
                )
              })}
            </Select>

            <CustomLabel>Selecione os grupos que deseja permitir o acesso</CustomLabel>
          </Column>
          <TextField
            margin="dense"
            label="Descrição"
            type="text"
            fullWidth
            variant="standard"
            helperText="Insira uma descrição para identificar a integração"
            value={integrationDescription}
            onChange={(ev: any) => {
              setIntegrationDescription(ev.target.value)
            }}
          />
          {!isEditingIntegration && (
            <TextField
              margin="dense"
              label="Código do Produto"
              type="text"
              fullWidth
              variant="standard"
              helperText="Insira o código do produto"
              value={integrationProdCode}
              onChange={(ev: any) => {
                setIntegrationProdCode(ev.target.value)
              }}
            />
          )}
          <TextField
            margin="dense"
            label="Origin Key"
            type="text"
            fullWidth
            variant="standard"
            helperText="Insira a origin key da plataforma"
            value={integrationToken}
            onChange={(ev: any) => {
              setIntegrationToken(ev.target.value)
            }}
          />
          <TextField
            margin="dense"
            label="Api Key"
            type="text"
            fullWidth
            variant="standard"
            helperText="Insira a api key para poder fazer imports automáticos"
            value={integrationApiKey}
            onChange={(ev: any) => {
              setIntegrationApiKey(ev.target.value)
            }}
          />
          {integrationPlatform === 0 && (
            <TextField
              margin="dense"
              label="Public Key"
              type="text"
              fullWidth
              variant="standard"
              helperText="Public key da Eduzz"
              value={integrationPublicKey}
              onChange={(ev: any) => {
                setIntegrationPublicKey(ev.target.value)
              }}
            />
          )}
          {integrationPlatform === 0 && (
            <TextField
              margin="dense"
              label="Eduzz Email"
              type="text"
              fullWidth
              variant="standard"
              helperText="Email da Eduzz"
              value={integrationEduzzEmail}
              onChange={(ev: any) => {
                setIntegrationEduzzEmail(ev.target.value)
              }}
            />
          )}
          <Row>
            {!isEditingIntegration && (
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label="Recorrência?"
                checked={integrationIsRecurrence}
                onChange={(ev: any) => {
                  setIntegrationIsRecurrence(ev.target.checked)
                }}
              />
            )}

            <TextField
              margin="dense"
              label="Expira em (dias)"
              type="number"
              fullWidth
              disabled={integrationIsRecurrence}
              variant="standard"
              helperText="Expira em (dias)"
              value={integrationExpiresIn}
              InputProps={{ inputProps: { min: 1 } }}
              onChange={(ev: any) => {
                setIntegrationExpiresIn(ev.target.value)
              }}
            />
          </Row>
          <TextField
            margin="dense"
            label="Remover cliente após (dias)"
            type="number"
            fullWidth
            disabled={!integrationIsRecurrence}
            variant="standard"
            helperText="Caso deixe em 0, assim que a assinatura/venda expirar o cliente será removido imediatamente"
            value={integrationDaysToRemove}
            InputProps={{ inputProps: { min: 0 } }}
            onChange={(ev: any) => {
              setIntegrationDaysToRemove(ev.target.value)
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ 'backgroundColor': '#B71D18', '&:hover': { backgroundColor: '#B71D18' } }}
            variant="contained"
            endIcon={<Clear />}
            onClick={() => {
              setIsIntegrationDialogOpen(false)
              setIsEditingGroup(false)
            }}
          >
            Cancelar
          </Button>
          <Button
            sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
            variant="contained"
            endIcon={<Add />}
            onClick={() => {
              if (isEditingIntegration) {
                editIntegration()
              } else {
                createIntegration()
              }
            }}
          >
            {isEditingIntegration ? 'Editar' : 'Criar'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isSectionDialogOpen}>
        <DialogTitle>Criar Separador</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Nome"
            type="text"
            fullWidth
            variant="standard"
            value={sectionName}
            helperText="Insira o nome do separador"
            onChange={(ev: any) => {
              setSectionName(ev.target.value)
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ 'backgroundColor': '#B71D18', '&:hover': { backgroundColor: '#B71D18' } }}
            variant="contained"
            endIcon={<Clear />}
            onClick={() => {
              setIsSectionDialogOpen(false)
            }}
          >
            Cancelar
          </Button>
          <Button
            sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
            variant="contained"
            endIcon={<Add />}
            onClick={() => {
              createSection()
            }}
          >
            {isEditingGroup ? 'Editar' : 'Criar'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isGroupDialogOpen}>
        <DialogTitle>{isEditingGroup ? 'Editar Grupo' : 'Criar Grupo'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Nome"
            type="text"
            fullWidth
            variant="standard"
            value={groupName}
            helperText="Insira o nome do grupo ou canal"
            onChange={(ev: any) => {
              setGroupName(ev.target.value)
            }}
          />

          {!isEditingGroup && (
            <TextField
              margin="dense"
              label="ChatId"
              type="text"
              fullWidth
              variant="standard"
              value={chatId}
              helperText="ChatId"
              onChange={(ev: any) => {
                setChatId(ev.target.value)
              }}
            />
          )}

          <TextField
            margin="dense"
            label="Link"
            type="text"
            fullWidth
            variant="standard"
            value={groupLink}
            helperText="Insira o link do grupo ou canal"
            onChange={(ev: any) => {
              setGroupLink(ev.target.value)
            }}
          />

          <Column>
            <Select
              margin="dense"
              variant="standard"
              fullWidth
              value={section}
              multiple={false}
              onChange={(ev: any) => {
                setSection(ev.target.value)
              }}
            >
              {sections.map((section: any, i) => {
                return (
                  <MenuItem key={i} value={section.id}>
                    {section.name}
                  </MenuItem>
                )
              })}
            </Select>

            <CustomLabel>Separador (opcional)</CustomLabel>
          </Column>

          <FormControlLabel
            label="Monitorar"
            checked={groupWatch}
            control={<Checkbox onChange={(ev: any) => setGroupWatch(ev.target.checked)} />}
          />
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ 'backgroundColor': '#B71D18', '&:hover': { backgroundColor: '#B71D18' } }}
            variant="contained"
            endIcon={<Clear />}
            onClick={() => {
              setIsGroupDialogOpen(false)
              if (isEditingGroup) {
                setIsEditingGroup(false)
              }
            }}
          >
            Cancelar
          </Button>
          <Button
            sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
            variant="contained"
            endIcon={<Add />}
            onClick={() => {
              if (isEditingGroup) {
                editGroup()
              } else {
                createGroup()
              }
            }}
          >
            {isEditingGroup ? 'Editar' : 'Criar'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isAccessDialogOpen}>
        <DialogTitle>{isEditingAccess ? 'Editar acesso' : 'Criar acesso'}</DialogTitle>
        <DialogContent>
          <Column style={{ marginTop: '16px' }}>
            <Select
              margin="dense"
              variant="standard"
              fullWidth
              value={accessIntegration}
              onChange={(ev: any) => {
                setAccessIntegration(ev.target.value)
              }}
            >
              {integrationList.map((integration: any) => {
                return (
                  <MenuItem key={integration.id} value={integration.id}>
                    {integration.description}
                  </MenuItem>
                )
              })}
            </Select>

            <CustomLabel>Selecione a integração do acesso</CustomLabel>
          </Column>

          <FormControlLabel
            label="Ativo?"
            checked={accessActive}
            control={<Checkbox onChange={(ev: any) => setAccessActive(ev.target.checked)} />}
          />

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span>Expira em:</span>

            <input
              type="date"
              style={{ marginTop: '10px' }}
              value={accessDate}
              onChange={(ev) => setAccessDate(ev.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ 'backgroundColor': '#B71D18', '&:hover': { backgroundColor: '#B71D18' } }}
            variant="contained"
            endIcon={<Clear />}
            onClick={() => {
              setIsAccessDialogOpen(false)
            }}
          >
            Cancelar
          </Button>
          <Button
            sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
            variant="contained"
            endIcon={<Add />}
            onClick={() => {
              if (isEditingAccess) {
                updateAccess()
              } else {
                createAccess()
              }
            }}
          >
            {isEditingAccess ? 'Editar' : 'Criar'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isClientDialogOpen}>
        <DialogTitle>{isEditingClients ? 'Editar cliente' : 'Criar cliente'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Nome"
            type="text"
            fullWidth
            variant="standard"
            value={clientName}
            helperText="Insira o nome do cliente"
            onChange={(ev: any) => {
              setClientName(ev.target.value)
            }}
          />

          <TextField
            margin="dense"
            label="Email"
            type="text"
            fullWidth
            variant="standard"
            value={clientEmail}
            helperText="Insira o email do cliente"
            onChange={(ev: any) => {
              setClientEmail(ev.target.value)
            }}
          />

          <TextField
            margin="dense"
            label="Telefone"
            type="text"
            fullWidth
            variant="standard"
            value={clientPhone}
            helperText="Insira o telefone do cliente"
            onChange={(ev: any) => {
              setClientPhone(ev.target.value)
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ 'backgroundColor': '#B71D18', '&:hover': { backgroundColor: '#B71D18' } }}
            variant="contained"
            endIcon={<Clear />}
            onClick={() => {
              setIsEditingClients(false)
              setIsClientDialogOpen(false)
            }}
          >
            Cancelar
          </Button>
          <Button
            sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
            variant="contained"
            endIcon={<Add />}
            onClick={() => {
              if (isEditingClients) {
                editClient()
              } else {
                createClient()
              }
            }}
          >
            {isEditingClients ? 'Editar' : 'Criar'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isWhitelistDialogOpen}>
        <DialogTitle>{isEditingWhitelist ? 'Editar Whitelist' : 'Criar Whitelist'}</DialogTitle>
        <DialogContent sx={{ minWidth: '20vw' }}>
          <TextField
            margin="dense"
            label="Nome"
            type="text"
            fullWidth
            variant="standard"
            value={whitelistName}
            helperText="Insira o nome da whitelist"
            onChange={(ev: any) => {
              setWhitelistName(ev.target.value)
            }}
          />

          <Column style={{ marginTop: '16px' }}>
            <Select
              margin="dense"
              multiple
              variant="standard"
              fullWidth
              value={whitelistGroups}
              onChange={(ev: any) => {
                setWhitelistGroups(ev.target.value)
              }}
            >
              {groupsList.map((group: any) => {
                return (
                  <MenuItem key={group.id} value={group.id}>
                    {group.name}
                  </MenuItem>
                )
              })}
            </Select>

            <CustomLabel>Selecione os grupos que deseja permitir o acesso</CustomLabel>
          </Column>

          <WhitelistDateRow>
            <FormControlLabel
              control={<Checkbox defaultChecked />}
              label="Vitalício?"
              checked={whitelistLifetime}
              onChange={(ev: any) => {
                setWhitelistLifetime(ev.target.checked)
              }}
            />

            <input
              type="date"
              disabled={whitelistLifetime}
              value={whitelistExpireAt}
              onChange={(ev: any) => {
                setWhitelistExpireAt(ev.target.value)
              }}
            />
          </WhitelistDateRow>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ 'backgroundColor': '#B71D18', '&:hover': { backgroundColor: '#B71D18' } }}
            variant="contained"
            endIcon={<Clear />}
            onClick={() => {
              setIsWhitelistDialogOpen(false)
            }}
          >
            Cancelar
          </Button>
          <Button
            sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
            variant="contained"
            endIcon={<Add />}
            onClick={() => {
              if (isEditingWhitelist) {
                updateWhitelist()
              } else {
                createWhitelist()
              }
            }}
          >
            Criar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isAuthDialogOpen}>
        <DialogTitle>Autenticar no Telegram</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Esse login é necessário para fazermos as remoções no seu grupo/canal, fique tranquilo
            seus dados estão seguros.
          </DialogContentText>
          <Wrapper>
            {isWaitingCode ? (
              <MuiPhoneNumber
                fullWidth
                defaultCountry={'br'}
                onChange={(value) => {
                  setNumber(value)
                }}
              />
            ) : (
              <TextField
                margin="dense"
                label="Código"
                type="text"
                fullWidth
                variant="standard"
                helperText="Insira o código enviado ao seu telegram"
                onChange={(ev: any) => {
                  setCode(ev.target.value)
                }}
              />
            )}
          </Wrapper>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ 'backgroundColor': '#006C9C', '&:hover': { backgroundColor: '#006C9C' } }}
            variant="contained"
            endIcon={isWaitingCode ? <ArrowRightAlt /> : <Cloud />}
            onClick={() => {
              if (isWaitingCode) {
                sendPhone()
              } else {
                sendCode()
              }
            }}
          >
            {isWaitingCode ? 'Próximo' : 'Autenticar'}
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  )
}

export default BotAdm
